import type { SVGProps } from 'react';

export const SvgIconCategory190 = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.625 10.125H5.625C5.07272 10.125 4.625 10.5727 4.625 11.125V15.125C4.625 15.6773 5.07272 16.125 5.625 16.125H27.625C28.1773 16.125 28.625 15.6773 28.625 15.125V11.125C28.625 10.5727 28.1773 10.125 27.625 10.125Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.625 16.125V25.125C26.625 25.3902 26.5196 25.6446 26.3321 25.8321C26.1446 26.0196 25.8902 26.125 25.625 26.125H7.625C7.35978 26.125 7.10543 26.0196 6.91789 25.8321C6.73036 25.6446 6.625 25.3902 6.625 25.125V16.125"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16.625 10.125V26.125" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M22.2875 8.71614C20.8625 10.1286 16.625 10.1286 16.625 10.1286C16.625 10.1286 16.625 5.89114 18.0375 4.46614C18.6011 3.90256 19.3655 3.58594 20.1625 3.58594C20.9595 3.58594 21.7239 3.90256 22.2875 4.46614C22.8511 5.02973 23.1677 5.79411 23.1677 6.59114C23.1677 7.38817 22.8511 8.15256 22.2875 8.71614V8.71614Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9622 8.71614C12.3872 10.1286 16.6247 10.1286 16.6247 10.1286C16.6247 10.1286 16.6247 5.89114 15.2122 4.46614C14.6486 3.90256 13.8843 3.58594 13.0872 3.58594C12.2902 3.58594 11.5258 3.90256 10.9622 4.46614C10.3986 5.02973 10.082 5.79411 10.082 6.59114C10.082 7.38817 10.3986 8.15256 10.9622 8.71614V8.71614Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
